import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C11.925 0 1.197 10.037.095 22.826h49.809C48.802 10.037 38.074 0 24.999 0ZM25 50c13.074 0 23.802-10.037 24.904-22.826H.095C1.197 39.963 11.925 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m20.652 33.696-2.8 1.318 1.49 2.712-3.041-.581-.385 3.072-2.12-2.26-2.118 2.26-.385-3.072-3.042.581 1.491-2.712-2.8-1.318 2.8-1.318-1.491-2.713 3.042.582.385-3.073 2.119 2.26 2.119-2.26.385 3.073 3.042-.582-1.492 2.713 2.802 1.318Z"
}));
FlagNR.displayName = 'FlagNR';
export default withFlagWrapper(FlagNR);
//# sourceMappingURL=index.js.map